import { Button, Icon, Link, Tooltip, Typography, palette } from "@callcenter/design-system"
import { t } from "i18next"
import { Trans } from "react-i18next"
import { useUnit } from "effector-react"

import { selfServiceModel, trialBalanceModel } from "../../models"

import styles from "./styles.module.pcss"

export const TrialExpiringTopHeaderMessage = () => {
  const isUpgradeDisabled = useUnit(selfServiceModel.$isUpgradeDisabled)
  const isFeatureEnabled = useUnit(selfServiceModel.$isSelfServiceMode)
  const trialDaysRemaining = useUnit(selfServiceModel.$trialDaysRemaining)
  const hasBalanceWarning = useUnit(trialBalanceModel.$hasTrialBalanceWarning)

  const actions = useUnit({
    upgradeNow: selfServiceModel.upgradeNowClicked,
    contactUsClicked: selfServiceModel.contactUsClicked
  })

  if (!isFeatureEnabled || hasBalanceWarning) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <Icon icon={Icon.icons.system.s.stateIndicators.information} size={16} color={palette.blue6} />

          <Typography.Body2>
            {trialDaysRemaining === 1 ? (
              <Trans
                i18nKey="component_commonKeys_selfService_trialPeriod_expireToday"
                components={{
                  bold: <strong />
                }}
              />
            ) : (
              <Trans
                i18nKey="component_commonKeys_selfService_trialPeriod_expireSoon"
                values={{
                  days: trialDaysRemaining
                }}
                components={{
                  bold: <strong />
                }}
              />
            )}
          </Typography.Body2>
        </div>

        <div className={styles.right}>
          <Link onClick={actions.contactUsClicked}>{t("component_commonKeys_contactUsButton_contactUsButton")}</Link>
          <Tooltip
            isVisibleDisabled={!isUpgradeDisabled}
            title={t("component_commonKeys_selfService_upgradeRequestSent_tooltipText")}
            position="aboveCenter"
          >
            <Button onClick={actions.upgradeNow} isDisabled={isUpgradeDisabled}>
              {t("component_commonKeys_trialExpired_upgradeButton")}
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
